import { render, staticRenderFns } from "./EstablishmentStateWaitingForInformation.vue?vue&type=template&id=47bf0c22&scoped=true&"
import script from "./EstablishmentStateWaitingForInformation.vue?vue&type=script&lang=js&"
export * from "./EstablishmentStateWaitingForInformation.vue?vue&type=script&lang=js&"
import style0 from "./EstablishmentStateWaitingForInformation.vue?vue&type=style&index=0&id=47bf0c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf0c22",
  null
  
)

component.options.__file = "EstablishmentStateWaitingForInformation.vue"
export default component.exports